import { supabase } from "@/lib/supabase";

// Lead/Contact form submission
export async function postLead(payload: {
  name: string;
  email: string;
  phone?: string;
  message?: string;
  service?: string;
  newsletter_opt_in?: boolean;
}) {
  // Insert into database
  const { data, error } = await supabase
    .from('leads')
    .insert({
      name: payload.name,
      email: payload.email,
      phone: payload.phone || null,
      message: payload.message || null,
      service: payload.service || null,
      newsletter_opt_in: payload.newsletter_opt_in || false,
    })
    .select()
    .single();

  if (error) {
    console.error('Error submitting lead:', error);
    throw error;
  }

  // Send email notifications via Mailjet edge function
  try {
    const { error: emailError } = await supabase.functions.invoke('send-contact-email', {
      body: {
        name: payload.name,
        email: payload.email,
        phone: payload.phone,
        service: payload.service,
        message: payload.message,
        newsletter_opt_in: payload.newsletter_opt_in,
      },
    });

    if (emailError) {
      console.error('Error sending contact emails:', emailError);
      // Don't throw - the lead was saved, email is secondary
    }
  } catch (emailErr) {
    console.error('Error invoking email function:', emailErr);
    // Don't throw - the lead was saved, email is secondary
  }

  return data;
}

// Blog articles
export async function getBlogArticles() {
  const { data, error } = await supabase
    .from('blog_articles')
    .select('*')
    .eq('published', true)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }

  return data;
}

export async function getBlogArticle(id: string) {
  const { data, error } = await supabase
    .from('blog_articles')
    .select('*')
    .eq('id', id)
    .eq('published', true)
    .maybeSingle();

  if (error) {
    console.error('Error fetching article:', error);
    throw error;
  }

  return data;
}

// Dashboard stats (admin only)
export async function getDashboardStats() {
  const { count: leadsCount, error: leadsError } = await supabase
    .from('leads')
    .select('*', { count: 'exact', head: true });

  if (leadsError) {
    console.error('Error fetching leads count:', leadsError);
  }

  const { count: articlesCount, error: articlesError } = await supabase
    .from('blog_articles')
    .select('*', { count: 'exact', head: true });

  if (articlesError) {
    console.error('Error fetching articles count:', articlesError);
  }

  return {
    total_leads: leadsCount || 0,
    total_articles: articlesCount || 0,
  };
}

// Get all leads (admin only)
export async function getLeads() {
  const { data, error } = await supabase
    .from('leads')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching leads:', error);
    throw error;
  }

  return data;
}
